export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "personalized_report_2025": "మీ భవిష్యత్తు కోసం 2025 వ్యక్తిగతీకరించిన జ్యోతిష్య సూచనలు",
    "comprehensive_life_blueprint": "సమగ్ర జీవిత బ్లూప్రింట్",
    "personalized_report_2025_description": "2025 మీ పూర్తి వ్యక్తిగతీకరించిన జ్యోతిష్య విశ్లేషణను పొందండి. కెరీర్, ప్రేమ, ఆర్థికం, ఆరోగ్యం, కుటుంబం, ఆధ్యాత్మిక వృద్ధి వంటి అన్ని జీవిత రంగాలపై సమగ్ర అంతర్దృష్టులు, నెలవారీ మార్గదర్శకత మరియు వ్యక్తిగత పరిహారాలతో అందించబడుతుంది.",

    // Service Information
    "enter_details_for_personalized_analysis": "వ్యక్తిగతీకరించిన విశ్లేషణ 2025 కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_personalized_analysis_2025": "పూర్ణ వ్యక్తిగతీకరించిన విశ్లేషణ 2025",
    "service_price": "సేవా ధర",
    "comprehensive_personalized_analysis_note": "2025 భవిష్యవాణులు మరియు వ్యక్తిగతీకరించిన మార్గదర్శనంతో పూర్తి జీవిత విశ్లేషణ",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_personalized_analysis": "మీ పేరు వ్యక్తిగతీకరించిన జ్యోతిష్య విశ్లేషణ కోసం ప్రత్యేకమైన కంపనలను సృష్టిస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_comprehensive_analysis": "సమగ్ర జ్యోతిష్య చార్ట్ మరియు 2025 భవిష్యవాణుల కోసం అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_comprehensive_analysis": "ఖచ్చితమైన భావ గణనలు మరియు వివరణాత్మక విశ్లేషణ కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_personalized_analysis": "వ్యక్తిగతీకరించిన భవిష్యవాణుల కోసం స్థానం గ్రహ స్థానాలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ వ్యక్తిగతీకరించిన నివేదిక ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core 2025 Features
    "comprehensive_life_analysis": "సమగ్ర జీవిత విశ్లేషణ",
    "year_2025_predictions": "సంవత్సరం 2025 భవిష్యవాణులు",
    "all_life_areas_analysis": "అన్ని జీవిత రంగాల విశ్లేషణ",
    "personalized_remedies_solutions": "వ్యక్తిగతీకరించిన పరిహారాలు మరియు పరిష్కారాలు",
    "monthly_guidance_2025": "మాసిక మార్గదర్శనం 2025",
    "premium_pdf_report": "ప్రీమియం PDF నివేదిక",

    "what_you_get": "మీ వ్యక్తిగతీకరించిన నివేదిక 2025లో ఉన్నవి",
    "complete_life_blueprint": "పూర్ణ జీవిత బ్లూప్రింట్",
    "year_2025_forecast": "సంవత్సరం 2025 అంచనా",
    "personalized_remedies": "వ్యక్తిగతీకరించిన పరిహారాలు",
    "monthly_predictions_guide": "మాసిక భవిష్యవాణుల గైడ్",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా వ్యక్తిగతీకరించిన నివేదిక 2025 పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "personalized_analysis_processing": "2025కి మీ సమగ్ర వ్యక్తిగతీకరించిన నివేదిక మా నిపుణ జ్యోతిష్యులచే తయారు చేయబడుతోంది. నెల వారీ మార్గదర్శనంతో అన్ని జీవిత రంగాలను కవర్ చేసే వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_48_hours_delivery_note": "మీ సమగ్ర వ్యక్తిగతీకరించిన నివేదిక 48 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ వ్యక్తిగతీకరించిన నివేదిక 2025 ప్యాకేజ్",
    "comprehensive_personalized_report": "సమగ్ర వ్యక్తిగతీకరించిన నివేదిక (PDF)",
    "complete_2025_predictions": "పూర్ణ 2025 భవిష్యవాణులు",
    "all_life_areas_detailed_analysis": "అన్ని జీవిత రంగాల వివరణాత్మక విశ్లేషణ",
    "personalized_remedies_guide": "వ్యక్తిగతీకరించిన పరిహారాల గైడ్",
    "monthly_action_plan_2025": "మాసిక కార్య ప్రణాళిక 2025",

    // Visual Content
    "sample_personalized_analysis_2025": "నమూనా వ్యక్తిగతీకరించిన విశ్లేషణ 2025",
    "year_2025_focus": "సంవత్సరం 2025 దృష్టి",
    "sample_2025_reading": "ఆర్థిక విస్తరణతో కెరీర్ వృద్ధి మరియు సంబంధ స్థిరత్వం",
    "sample_2025_preview": "సమగ్ర అంతర్దృష్టులతో మీ వ్యక్తిగతీకరించిన 2025 విశ్లేషణ మునుజూపు",
    "year_2025_analysis_areas": "సంవత్సరం 2025 విశ్లేషణ రంగాలు",

    // 2025 Life Area Types
    "career_2025": "కెరీర్ 2025",
    "love_2025": "ప్రేమ 2025",
    "finance_2025": "ఆర్థికం 2025",
    "health_2025": "ఆరోగ్యం 2025",
    "family_2025": "కుటుంబం 2025",
    "spiritual_2025": "ఆధ్యాత్మికం 2025",

    // Status & Processing
    "your_personalized_analysis_status": "మీ వ్యక్తిగతీకరించిన విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ వ్యక్తిగతీకరించిన నివేదిక 2025ను సృష్టిస్తోంది",
    "analysis_processing_message": "మా నిపుణ జ్యోతిష్యులు వివరణాత్మక 2025 భవిష్యవాణులు మరియు నెల వారీ మార్గదర్శనంతో అన్ని జీవిత రంగాలను కవర్ చేసే మీ సమగ్ర వ్యక్తిగతీకరించిన నివేదికను తయారు చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_48_hours": "48 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "ప్రీమియం మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // 2025 Year Overview
    "year_2025_overview": "సంవత్సరం 2025 సమీక్ష",
    "major_planetary_transits_2025": "ప్రధాన గ్రహ గమనాలు 2025",
    "key_astrological_events_2025": "ప్రధాన జ్యోతిష్య సంఘటనలు 2025",
    "annual_theme_2025": "వార్షిక థీమ్ 2025",
    "yearly_opportunities": "వార్షిక అవకాశాలు",
    "yearly_challenges": "వార్షిక సవాళ్లు",

    // Monthly Analysis 2025
    "january_2025": "జనవరి 2025",
    "february_2025": "ఫిబ్రవరి 2025",
    "march_2025": "మార్చి 2025",
    "april_2025": "ఏప్రిల్ 2025",
    "may_2025": "మే 2025",
    "june_2025": "జూన్ 2025",
    "july_2025": "జులై 2025",
    "august_2025": "ఆగస్టు 2025",
    "september_2025": "సెప్టెంబర్ 2025",
    "october_2025": "అక్టోబర్ 2025",
    "november_2025": "నవంబర్ 2025",
    "december_2025": "డిసెంబర్ 2025",

    // Career 2025
    "career_forecast_2025": "కెరీర్ అంచనా 2025",
    "professional_growth_2025": "వృత్తిపరమైన వృద్ధి అవకాశాలు",
    "job_changes_2025": "ఉద్యోగ మార్పులు మరియు పరివర్తనలు",
    "business_prospects_2025": "వ్యాపార అవకాశాలు 2025",
    "leadership_opportunities_2025": "నాయకత్వ అవకాశాలు",
    "salary_increment_timing": "జీతం పెరుగుదల సమయం",
    "career_challenges_2025": "నావిగేట్ చేయవలసిన కెరీర్ సవాళ్లు",

    // Finance 2025
    "financial_forecast_2025": "ఆర్థిక అంచనా 2025",
    "income_growth_2025": "ఆదాయ వృద్ధి సంభావ్యత",
    "investment_opportunities": "పెట్టుబడి అవకాశాలు",
    "expenditure_patterns": "వ్యయ నమూనాలు",
    "wealth_accumulation": "సంపద సంచయన కాలక్రమం",
    "financial_challenges": "ఆర్థిక సవాళ్లు",
    "money_management_tips": "డబ్బు నిర్వహణ చిట్కాలు",

    // Love & Relationships 2025
    "love_forecast_2025": "ప్రేమ అంచనా 2025",
    "relationship_developments": "సంబంధ అభివృద్ధిలు",
    "marriage_prospects_2025": "వివాహ అవకాశాలు 2025",
    "family_harmony": "కుటుంబ సామరస్య అంచనా",
    "romantic_opportunities": "శృంగార అవకాశాలు",
    "relationship_challenges": "సంబంధ సవాళ్లు",
    "love_life_enhancement": "ప్రేమ జీవిత మెరుగుదల",

    // Health 2025
    "health_forecast_2025": "ఆరోగ్య అంచనా 2025",
    "vitality_levels": "2025 అంతటా జీవశక్తి స్థాయిలు",
    "health_vulnerable_periods": "ఆరోగ్య బలహీనత కాలాలు",
    "wellness_recommendations": "ఆరోగ్య సిఫార్సులు",
    "fitness_goals_2025": "ఫిట్‌నెస్ లక్ష్యాలు 2025",
    "mental_health_focus": "మానసిక ఆరోగ్య దృష్టి రంగాలు",
    "preventive_care_guidance": "నివారణ సంరక్షణ మార్గదర్శనం",

    // Spiritual Growth 2025
    "spiritual_journey_2025": "ఆధ్యాత్మిక యాత్ర 2025",
    "meditation_practices": "సిఫార్సు చేయబడిన ధ్యాన అభ్యాసాలు",
    "spiritual_awakening": "ఆధ్యాత్మిక మేల్కొలుపు అవకాశాలు",
    "inner_growth_phases": "అంతర్గత వృద్ధి దశలు",
    "divine_connections": "దైవిక సంబంధాలు",
    "karmic_lessons_2025": "కర్మ పాఠాలు 2025",

    // Personalized Remedies
    "customized_remedies": "2025కి అనుకూలీకరించిన పరిహారాలు",
    "gemstone_recommendations": "రత్న సిఫార్సులు",
    "mantra_suggestions": "మంత్ర సూచనలు",
    "ritual_guidance": "కర్మ మార్గదర్శనం",
    "charitable_activities": "లాభదాయకమైన దాతృత్వ కార్యకలాపాలు",
    "lifestyle_modifications": "జీవనశైలి మార్పులు",
    "lucky_colors_2025": "2025కి అదృష్ట రంగులు",
    "auspicious_dates": "మంగళకరమైన తేదీలు మరియు సమయం",

    // Timing & Cycles
    "auspicious_periods_2025": "మంగళకరమైన కాలాలు 2025",
    "challenging_periods": "నావిగేట్ చేయవలసిన సవాలు కాలాలు",
    "optimal_decision_timing": "అనువైన నిర్ణయ తీసుకునే సమయాలు",
    "new_venture_timing": "కొత్త వెంచర్ లాంచ్ సమయం",
    "travel_recommendations": "ప్రయాణ సిఫార్సులు",
    "important_date_alerts": "ముఖ్యమైన తేదీ హెచ్చరికలు",

    // Personal Development 2025
    "skill_development_2025": "నైపుణ్య అభివృద్ధి దృష్టి 2025",
    "learning_opportunities": "అభ్యాస అవకాశాలు",
    "personal_growth_areas": "వ్యక్తిగత వృద్ధి రంగాలు",
    "character_development": "వ్యక్తిత్వ అభివృద్ధి దృష్టి",
    "habit_formation": "లాభదాయకమైన అలవాటు ఏర్పాటు",
    "goal_achievement_strategy": "లక్ష్య సాధన వ్యూహం",

    // Social & Networking 2025
    "social_connections_2025": "సామాజిక సంబంధాలు 2025",
    "networking_opportunities": "నెట్‌వర్కింగ్ అవకాశాలు",
    "friendship_developments": "మిత్రత్వ అభివృద్ధిలు",
    "community_involvement": "కమ్యూనిటీ పాల్గొనడం",
    "social_influence_growth": "సామాజిక ప్రభావ వృద్ధి",

    // Technology & Innovation 2025
    "technology_adoption": "టెక్నాలజీ స్వీకరణ మార్గదర్శనం",
    "digital_opportunities": "డిజిటల్ అవకాశాలు",
    "innovation_potential": "ఆవిష్కరణ సంభావ్యత",
    "online_presence": "ఆన్‌లైన్ ఉనికి మెరుగుదల",
    "digital_financial_growth": "డిజిటల్ ఆర్థిక వృద్ధి",

    // Travel & Relocation 2025
    "travel_forecast_2025": "ప్రయాణ అంచనా 2025",
    "relocation_possibilities": "స్థలాంతర అవకాశాలు",
    "foreign_opportunities": "విదేశీ అవకాశాలు",
    "pilgrimage_recommendations": "తీర్థయాత్ర సిఫార్సులు",
    "educational_travel": "విద్యా ప్రయాణం",

    // Legal & Official Matters 2025
    "legal_matters_guidance": "న్యాయ విషయాల మార్గదర్శనం",
    "official_work_timing": "అధికారిక పని సమయం",
    "documentation_periods": "అనుకూలమైన డాక్యుమెంటేషన్ కాలాలు",
    "government_dealings": "ప్రభుత్వ వ్యవహారాలు",
    "property_matters": "ఆస్తి సంబంధిత విషయాలు",

    // Creative & Artistic 2025
    "creative_expression_2025": "సృజనాత్మక వ్యక్తీకరణ 2025",
    "artistic_pursuits": "కళాత్మక కార్యకలాపాలు",
    "creative_projects": "సృజనాత్మక ప్రాజెక్ట్ల సమయం",
    "artistic_collaborations": "కళాత్మక సహకారాలు",
    "creative_income_potential": "సృజనాత్మక ఆదాయ సంభావ్యత",

    // Education & Knowledge 2025
    "educational_pursuits": "విద్యా కార్యకలాపాలు 2025",
    "skill_certifications": "నైపుణ్య సర్టిఫికేషన్లు",
    "knowledge_expansion": "జ్ఞాన విస్తరణ రంగాలు",
    "research_projects": "పరిశోధన ప్రాజెక్ట్లు",
    "teaching_opportunities": "బోధన అవకాశాలు",

    // Environmental & Lifestyle 2025
    "living_environment": "జీవన వాతావరణ మార్పులు",
    "lifestyle_upgrades": "జీవనశైలి అప్‌గ్రేడ్‌లు",
    "home_improvements": "గృహ మెరుగుదలల సమయం",
    "environmental_consciousness": "పర్యావరణ చైతన్యం",
    "sustainable_living": "స్థిరమైన జీవన అభ్యాసాలు"
};
